import React from "react";
import MenuCard from "../../components/menu-card";

export default function StepFive(props) {
  const focus = 5;

  return <MenuCard focus={focus} />;
}
